/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePlanTbLevelEnum =
  (typeof RoutePlanTbLevelEnum)[keyof typeof RoutePlanTbLevelEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePlanTbLevelEnum = {
  Unknown: 0,
  Green: 1,
  Yellow: 2,
  Red: 3,
} as const;
